/**
 * AdSense のパブリッシャー ID。
 *
 * 公開情報で、秘匿する必要はない。実際 `public/ads.txt` にも同じ値が載っており
 * (あちらは `ca-` の付かない `pub-…` 形式)、ページのソースにも出る。
 * 環境変数にせずここに置いてあるのは、サイトに紐づく固定値だからで、
 * デプロイのたびに渡し忘れると広告が黙って消えるのを避けるため。
 *
 * ビルド時の `VITE_ADSENSE_CLIENT_ID` で上書きできる (別アカウントで試すとき用)。
 *
 * この値を使う場所は 2 つある。
 *   - index.html に差し込む配信スクリプト (vite.config.ts)
 *   - 各広告枠の data-ad-client (src/config.ts → AdSlot)
 */
export const ADSENSE_PUBLISHER_ID = "ca-pub-2520195342210610";

/**
 * 広告枠を出すかどうか。
 *
 * **現在は無効。** AdSense のサイトのステータスが「準備中」で、広告が返ってこない。
 * この状態で枠を置いても空白が並ぶだけなので、枠そのものを描画しない。
 * 確認用のスクリプトと ads.txt は審査のために残してある。
 *
 * サイトが「準備完了」になったら true に戻してデプロイする。
 * それだけで支出一覧と精算結果に広告が出る (スロット ID は下に入っている)。
 */
export const ADSENSE_ADS_ENABLED = false;

/**
 * 掲載面ごとの広告ユニット (スロット) ID。
 *
 * パブリッシャー ID と同じく公開情報 (ページのソースに data-ad-slot として出る) で、
 * サイトに紐づく固定値なのでここに置く。
 * 掲載面を増やすときは AdSense で広告ユニットを作り、この表に足す。
 *
 * サイズは AdSense で作ったユニットと `adSlotSize()` を揃えること。
 * ずれると枠と広告の大きさが合わず、余白や見切れの原因になる。
 *
 * ビルド時の `VITE_ADSENSE_SLOT_*` で上書きできる。
 */
export const ADSENSE_SLOTS = {
  /** 支出一覧の途中。ディスプレイ広告 320×50 */
  expenseList: "5501501394",
  /** 精算結果の下。ディスプレイ広告 300×250 */
  settlement: "2875338052",
} as const;
